// Karşılaştırma sonucunu yeni pencerede yazdırılabilir HTML olarak açar.
// Tarayıcının kendi "PDF olarak kaydet" seçeneği üzerinden PDF üretilir
// (jspdf/html2canvas gibi ek paketlere gerek yok).
function escapeHtml(s) {
  return String(s ?? '')
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

export function exportComparePdf({ items }) {
  if (!items || !items.length) return;
  const dateStr = new Date().toLocaleDateString('tr-TR', {day:'2-digit', month:'long', year:'numeric'});

  const headerCells = items.map(p => `
    <th>
      <div class="sname">${escapeHtml(p.name)}</div>
      <div class="smeta">${escapeHtml(p.type || '')} · ★ ${escapeHtml(p.rating ?? '-')}</div>
    </th>`).join('');

  const row = (label, vals) => `
    <tr>
      <td class="lbl">${escapeHtml(label)}</td>
      ${vals.map(v => `<td>${v == null || v === '' ? '—' : escapeHtml(v)}</td>`).join('')}
    </tr>`;

  const yn = (b) => b ? '✓' : '—';
  const has = (p, ...kws) => {
    const norm = s => (s||'').toLocaleLowerCase('tr');
    const arr = Array.isArray(p.features) ? p.features : [];
    return kws.some(k => arr.some(f => norm(f).includes(norm(k))));
  };

  const sections = [
    { title: 'GENEL BİLGİLER', rows: [
      ['Puan',     items.map(p => `★ ${p.rating ?? '-'} (${p.reviews ?? 0} yorum)`)],
      ['Aidat',    items.map(p => p.price)],
      ['Yaş',      items.map(p => p.age ? `${p.age} yaş` : '-')],
      ['Kapasite', items.map(p => p.capacity ? `${p.capacity} kişi` : '-')],
      ['Doluluk',  items.map(p => p.capacity ? `${Math.round((p.filled / p.capacity) * 100)}%` : '-')],
      ['Çalışma',  items.map(p => p.hours)],
      ['Adres',    items.map(p => p.city || p.address || '-')],
    ]},
    { title: 'EĞİTİM', rows: [
      ['Montessori', items.map(p => yn(has(p, 'montessori')))],
      ['Reggio',     items.map(p => yn(has(p, 'reggio')))],
      ['Waldorf',    items.map(p => yn(has(p, 'waldorf')))],
      ['STEM',       items.map(p => yn(has(p, 'stem', 'steam', 'kodlama', 'robotik')))],
      ['Sanat/Müzik',items.map(p => yn(has(p, 'sanat', 'müzik', 'muzik', 'dans', 'resim')))],
    ]},
    { title: 'TESİS', rows: [
      ['Bahçe',    items.map(p => yn(has(p, 'bahçe', 'bahce', 'doğa')))],
      ['Havuz',    items.map(p => yn(has(p, 'havuz', 'yüzme')))],
      ['Servis',   items.map(p => yn(has(p, 'servis', 'taşıma', 'araç')))],
      ['Yemekhane',items.map(p => yn(has(p, 'yemek', 'kantin', 'yemekhane')))],
      ['Kamera',   items.map(p => yn(has(p, 'kamera', 'güvenlik')))],
    ]},
  ];

  const tableBody = sections.map(sec => `
    <tr class="sec"><td colspan="${items.length + 1}">${escapeHtml(sec.title)}</td></tr>
    ${sec.rows.map(([l, vs]) => row(l, vs)).join('')}
  `).join('');

  const html = `<!doctype html>
<html lang="tr">
<head>
<meta charset="utf-8">
<title>OkulMap Karşılaştırma — ${escapeHtml(dateStr)}</title>
<style>
  * { box-sizing: border-box; }
  body { font-family: -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif; color: #1f2933; padding: 24px; max-width: 980px; margin: 0 auto; }
  h1 { font-size: 22px; margin: 0 0 4px; }
  .sub { color: #6b7280; font-size: 12px; margin-bottom: 24px; }
  table { width: 100%; border-collapse: collapse; font-size: 12px; }
  th, td { border: 1px solid #e5e7eb; padding: 8px 10px; text-align: left; vertical-align: top; }
  th { background: #f3f4f6; font-weight: 700; }
  th .sname { font-size: 13px; font-weight: 800; }
  th .smeta { font-size: 10px; color: #6b7280; margin-top: 2px; }
  td.lbl { background: #fafafa; color: #374151; font-weight: 600; width: 22%; }
  tr.sec td { background: #1f2933; color: #fff; font-weight: 800; font-size: 11px; letter-spacing: 0.06em; padding: 6px 10px; }
  .ai { margin-top: 20px; border: 1px solid #cbd5e0; border-radius: 8px; padding: 14px 16px; background: #f8fafc; }
  .ai-title { font-weight: 800; font-size: 13px; margin-bottom: 8px; }
  .ai-body { font-size: 12px; line-height: 1.6; white-space: pre-wrap; }
  .footer { margin-top: 28px; color: #9ca3af; font-size: 10px; text-align: center; }
  @media print {
    body { padding: 0; }
    @page { margin: 16mm; }
    .no-print { display: none; }
    tr { page-break-inside: avoid; }
  }
  .actions { display: flex; gap: 8px; justify-content: flex-end; margin-bottom: 16px; }
  .btn { padding: 8px 16px; border-radius: 8px; border: 1px solid #cbd5e0; background: #fff; cursor: pointer; font-size: 12px; font-weight: 600; }
  .btn.primary { background: #1f2933; color: #fff; border-color: #1f2933; }
</style>
</head>
<body>
  <div class="actions no-print">
    <button class="btn" onclick="window.close()">Kapat</button>
    <button class="btn primary" onclick="window.print()">PDF olarak indir</button>
  </div>
  <h1>OkulMap — Karşılaştırma Raporu</h1>
  <div class="sub">${escapeHtml(dateStr)} · ${items.length} okul · okulmap.com</div>
  <table>
    <thead>
      <tr>
        <th class="lbl"></th>
        ${headerCells}
      </tr>
    </thead>
    <tbody>
      ${tableBody}
    </tbody>
  </table>
  <div class="footer">Bu rapor okulmap.com üzerinden oluşturulmuştur.</div>
</body>
</html>`;

  const w = window.open('', '_blank');
  if (!w) {
    alert('Pop-up engellendi. PDF için tarayıcı pop-up iznini açmalısın.');
    return;
  }
  w.document.open();
  w.document.write(html);
  w.document.close();
  // Yazdırma diyaloğu kullanıcı isterse otomatik tetiklensin
  setTimeout(() => { try { w.focus(); w.print(); } catch (e) {} }, 400);
}
